<template>
  <div class="relative w-full" ref="dropdownContainer">
    <button
      @click="toggleDropdown"
      class="bg-red-500 text-white px-4 mb-4 py-2 rounded-md hover:bg-red-600 focus:outline-none w-full"
    >
      Add a question
    </button>

    <div
      v-if="isDropdownOpen"
      :class="['absolute z-10 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 max-h-64 overflow-y-auto', positionAbove ? 'bottom-full mb-2' : 'top-full']"
    >
      <div class="py-1">
        <button @click="selectQuestionType('Multiple Choice')" class="dropdown-item">Multiple Choice</button>
        <button @click="selectQuestionType('Fill the Gaps')" class="dropdown-item">Fill the Gaps</button>
        <button @click="selectQuestionType('Ordering')" class="dropdown-item">Ordering</button>
        <button @click="selectQuestionType('Match the Pairs')" class="dropdown-item">Match the Pairs</button>
        <button @click="selectQuestionType('Free Text')" class="dropdown-item">Free Text</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isDropdownOpen: false,
      positionAbove: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;

      if (this.isDropdownOpen) {
        this.$nextTick(() => {
          const rect = this.$refs.dropdownContainer.getBoundingClientRect();
          const spaceBelow = window.innerHeight - rect.bottom;
          this.positionAbove = spaceBelow < 200; // less than 200px space? Show above
        });
      }
    },
    selectQuestionType(type) {
      this.isDropdownOpen = false;
      this.$emit('add-question', type);
    },
    handleClickOutside(event) {
      if (!this.$refs.dropdownContainer.contains(event.target)) {
        this.isDropdownOpen = false;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>
<style scoped>
.dropdown-item {
  @apply block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 w-full text-left;
}
</style>
